import React from 'react';
import { LinearProgress } from '@mui/material';

function Loader() {
  return <LinearProgress />;
}

export default Loader;
